/**
 * User id for anonymous user.
 */
export var NOT_LOGGED_IN_USER_ID = -1;
//# sourceMappingURL=general.js.map